module.exports = __webpack_public_path__ + "img/Pista_17.d38a1597.png";